import React, { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { connect } from "formik";
import useWindowSize from "hooks/windowSize";
import { storage } from 'api/firebase';
import _ from 'lodash';
import { Container, DashBorder } from "./styles";
import { shape, string, func, number, bool } from "prop-types";
import { errorNotification } from "utils/notifications";
import user from "containers/user";
import { getFileURL, readFileAsync } from "utils/fileHelper";
import { Success, Default } from "./views";
import nprogress from "nprogress";

const DEFAULT_CONFIG = {
  maxSize: 12428800,
  accept: "application/pdf, image/jpeg, image/png, application/xls, application/doc, application/csv, text/csv, .csv, .xlsx, .doc, .docx",
  multiple: false,
  errMessage:
    'Please be sure the file does not exceed 10 MB',
};

const DropZone = ({
  formik,
  name,
  closeModal,
  config,
  onSubmit,
  imageCropper,
}) => {
  const [uploaded, setUploaded] = useState(false);
  const mobile = useWindowSize()[0] < 1366;
  const uuid = user.state.profile?.my_uuid_id;

  useEffect(() => {
    if (formik.values[name] === null || formik.values[name === undefined]) {
      setUploaded(false);
    }
  }, [formik.values, name]);

  const onDropRejected = useCallback(
    async (data) => {
      errorNotification(
        `Upload failed. ${Object.assign({}, DEFAULT_CONFIG, config).errMessage}`
      );
    },
    [config]
  );

  const onDropAccepted = useCallback(
    async (files) => {
      // const filesToSave = await Promise.all(
      //   files.map(async (file) => {
      //     const fileContents = await readFileAsync(file).catch(
      //       errorNotification
      //     );
      //     const formData = new FormData();
      //     formData.append("file", file);
      //     return {
      //       file,
      //       formData,
      //       fileURL: getFileURL(fileContents, file.type),
      //     };
      //   })
      // );

      // console.log('@@@@ filesToSave: ', filesToSave);

      _.forEach(files, file => {
        const uploadTask = storage.ref(`${uuid}/${file.name}`).put(file);
        nprogress.start();
        uploadTask.on(
          "state_changed",
          snapshot => {
            const progress = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes)
            );
            nprogress.set(progress);
          },
          error => {
            console.log(error);
          },
          () => {
            storage
              .ref(uuid)
              .child(file.name)
              .getDownloadURL()
              .then(url => {
                nprogress.done();
                setUploaded(true);
                formik.setFieldValue(name, {
                  file,
                  fileURL: url
                });
              });
          }
        );
      })
    },
    [formik, name, config]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropAccepted,
    onDropRejected,
    ...Object.assign({}, DEFAULT_CONFIG, config),
  });

  const onDone = () => {
    onSubmit();
    closeModal();
  };

  const acceptImage = config.accept.includes("image");
  const file = formik.values[name];
  return (
    <Container>
      <DashBorder image={file} uploaded={uploaded}>
        {uploaded ? (
          // imageCropper ? (
          //   imageCropper
          // ) : (
            <Success
              onDone={onDone}
              onReUpload={() => setUploaded(false)}
              image={file}
            />
          // )
        ) : (
          <div {...getRootProps()}>
            <input {...getInputProps()} name={name} />
            <Default {...{ isDragActive, mobile, acceptImage, name }} />
          </div>
        )}
      </DashBorder>
    </Container>
  );
};

export default connect(DropZone);

DropZone.defaultProps = {
  config: DEFAULT_CONFIG,
  closeModal: () => {},
  onSubmit: () => {},
};

DropZone.propTypes = {
  config: shape({
    maxSize: number,
    accept: string,
    multiple: bool,
  }),
  name: string.isRequired,
  closeModal: func,
  onSubmit: func,
};
